import { render, staticRenderFns } from "./TableHeaderCell.vue?vue&type=template&id=72473228&scoped=true"
import script from "./TableHeaderCell.vue?vue&type=script&lang=js"
export * from "./TableHeaderCell.vue?vue&type=script&lang=js"
import style0 from "./TableHeaderCell.vue?vue&type=style&index=0&id=72473228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72473228",
  null
  
)

export default component.exports